module.exports = __webpack_public_path__ + "static/media/gathering_img.69345d3f.png";